import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

export default function Footer({ onOpenCookiePrefs }) {
  const { t, lang } = useI18n();
  const year = new Date().getFullYear();
  const base = `/${lang}`;

  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 border-t border-slate-800 text-slate-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link
            to={base}
            data-testid="footer-logo"
            className="text-white font-bold text-lg tracking-tight"
          >
            Ecuproyecta
          </Link>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-md">
            {t("footer.tagline")}
          </p>
          <p className="mt-4 text-xs text-slate-500 leading-relaxed max-w-md">
            {t("footer.disclaimer")}
          </p>
        </div>

        <div>
          <h4 className="text-xs font-mono uppercase tracking-widest text-blue-400 mb-4">
            {t("footer.legalLabel")}
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                data-testid="footer-link-privacy"
                to={`${base}/privacy`}
                className="hover:text-white transition-colors"
              >
                {t("privacy.title")}
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-cookies"
                to={`${base}/cookies`}
                className="hover:text-white transition-colors"
              >
                {t("cookies.title")}
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-link-terms"
                to={`${base}/terms`}
                className="hover:text-white transition-colors"
              >
                {t("terms.title")}
              </Link>
            </li>
            <li>
              <button
                data-testid="footer-cookie-prefs"
                onClick={onOpenCookiePrefs}
                className="text-left hover:text-white transition-colors"
              >
                {t("cookieBanner.preferences")}
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-mono uppercase tracking-widest text-blue-400 mb-4">
            {t("footer.contactLabel")}
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <span className="text-slate-500">{t("footer.emailLabel")}: </span>
              <a
                data-testid="footer-email"
                href="mailto:contacto@ecuproyecta.com"
                className="hover:text-white transition-colors"
              >
                contacto@ecuproyecta.com
              </a>
            </li>
            <li>
              <span className="text-slate-500">{t("footer.phoneLabel")}: </span>
              <a
                data-testid="footer-phone"
                href="tel:+59323829400"
                className="hover:text-white transition-colors"
              >
                +593 (2) 382-9400
              </a>
            </li>
            <li className="pt-2 text-slate-400">
              <span className="text-slate-500">{t("footer.addressLabel")}: </span>
              Av. República de El Salvador N36-140 y Suecia, Edificio Millennium Plaza, Piso 8, Quito, Pichincha, Ecuador
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 grid grid-cols-1 md:grid-cols-2 gap-4 text-xs text-slate-500">
          <div className="space-y-1">
            <div>
              <span className="text-slate-400">Ecuproyecta Analítica &amp; Decisiones S.A.S.</span>
              {" · "}
              <span>{t("footer.rucLabel")}: 1793148920001</span>
            </div>
            <div>{t("footer.licenseLabel")}: {t("footer.licenseValue")}</div>
            <div>{t("footer.jurisdictionLabel")}: {t("footer.jurisdictionValue")}</div>
            <div>{t("footer.incorporatedLabel")}: {t("footer.incorporatedValue")}</div>
            <div>{t("footer.regulatorLabel")}: {t("footer.regulatorValue")}</div>
          </div>
          <div className="md:text-right">
            © {year} Ecuproyecta Analítica &amp; Decisiones S.A.S. {t("footer.rights")}
          </div>
        </div>
      </div>
    </footer>
  );
}
